/* eslint-disable no-template-curly-in-string */
import React, { createContext, useContext, useState } from 'react';

export const dictionaries = {
  ru: {
    // Navigation / Tabs
    tab_order: 'Заказ',
    tab_orders: 'Мои заказы',
    tab_wallet: 'Баланс',
    tab_referral: 'Партнёрка',

    // Days & Months
    wd_0: 'Вс', wd_1: 'Пн', wd_2: 'Вт', wd_3: 'Ср', wd_4: 'Чт', wd_5: 'Пт', wd_6: 'Сб',
    mon_0: 'янв', mon_1: 'фев', mon_2: 'мар', mon_3: 'апр', mon_4: 'мая', mon_5: 'июн',
    mon_6: 'июл', mon_7: 'авг', mon_8: 'сен', mon_9: 'окт', mon_10: 'ноя', mon_11: 'дек',
    month_full_0: 'Январь', month_full_1: 'Февраль', month_full_2: 'Март', month_full_3: 'Апрель',
    month_full_4: 'Май', month_full_5: 'Июнь', month_full_6: 'Июль', month_full_7: 'Август',
    month_full_8: 'Сентябрь', month_full_9: 'Октябрь', month_full_10: 'Ноябрь', month_full_11: 'Декабрь',
    cal_wd_mon: 'Пн', cal_wd_tue: 'Вт', cal_wd_wed: 'Ср', cal_wd_thu: 'Чт', cal_wd_fri: 'Пт', cal_wd_sat: 'Сб', cal_wd_sun: 'Вс',
    today: 'Сегодня',
    tomorrow: 'Завтра',
    seg_today: 'Сег',
    calendar_btn: 'Календарь',
    limit_30_days: 'До 30 дней',
    hours_unit: 'ч',
    min_unit: 'мин',

    // Onboarding
    onboard_title: 'Трафик в комнату на Stripchat по расписанию',
    onboard_sub: 'Выберите модель и час — продвижение включится само. Оплата с баланса, почасово.',
    onboard_step1_title: 'Пополните баланс',
    onboard_step1_desc: 'Криптой: BTC, ETH, USDT. Чем больше пополнение — тем дешевле час: $10 → $8 → $7.',
    onboard_step2_title: 'Выберите свободное время',
    onboard_step2_desc: 'Сетка показывает время в вашем часовом поясе. Занятые часы зачёркнуты.',
    onboard_step3_title: 'Будьте онлайн за 15 минут',
    onboard_step3_desc: 'Бот напомнит в Telegram. Продвижение стартует автоматически.',
    onboard_guide_link: 'Подробная инструкция',
    onboard_btn_order: 'Создать первый заказ',
    onboard_btn_wallet: 'Сначала пополнить баланс',

    // Order Form
    order_head_sub: 'Stripchat traffic',
    order_title: 'Новый заказ',
    model_label: 'Модель',
    model_placeholder: 'username',
    recent_label: 'Недавние:',
    date_label: 'Дата',
    start_time_label: 'Время старта',
    now_label: 'сейчас',
    legend_free: 'Свободно',
    legend_busy: 'Занято',
    legend_selected: 'Ваш заказ',
    duration_label: 'Длительность',
    online_note_prefix: 'Модель должна быть онлайн с',
    online_note_suffix: '— за 15 минут до старта.',
    how_it_works: 'Как это работает',
    err_empty_model: 'Укажите ник модели на Stripchat.',
    err_no_window: 'На этот день нет свободного окна такой длины — выберите другой день или уменьшите длительность.',
    err_hour_busy: '{time} уже занято — уменьшите длительность или сдвиньте старт.',
    err_after_midnight: 'Заказ должен закончиться до 24:00 — уменьшите длительность или выберите время раньше.',
    err_past_time: 'Это время уже прошло.',
    err_insufficient_prefix: 'Не хватает',
    err_insufficient_suffix: 'на балансе.',
    remaining_label: 'Остаток',
    btn_topup: 'Пополнить баланс',
    btn_select_free_time: 'Выберите свободное время',
    btn_loading_slots: 'Загружаем слоты…',
    btn_order_for: 'Заказать за ${cost}',
    btn_creating: 'Создаём…',

    // Confirm
    confirm_title: 'Заказ принят',
    starts_in: 'Старт через',
    summary_model: 'Модель',
    summary_date: 'Дата',
    summary_time: 'Время',
    summary_charged: 'Списано',
    summary_balance: 'Остаток',
    remind_telegram: 'Напомнить в Telegram',
    remind_telegram_sub: 'В {time} — за 30 минут до старта',
    confirm_online_note: 'Модель должна быть онлайн с {time}. Отменить заказ можно до старта — деньги вернутся на баланс.',
    btn_my_orders: 'Мои заказы',
    btn_another_order: 'Ещё один заказ',

    // Orders list
    orders_title: 'Мои заказы',
    tab_upcoming: 'Предстоящие',
    tab_history: 'История',
    status_running: 'Идёт',
    status_scheduled: 'Запланирован',
    status_completed: 'Завершён',
    status_cancelled: 'Отменён',
    left_label: 'Осталось',
    online_from: 'онлайн с',
    remind_tag: 'напомним',
    refunded_label: 'возвращено',
    btn_cancel: 'Отменить',
    btn_repeat: 'Повторить',
    btn_new_order: '+ Новый заказ',
    empty_upcoming: 'Нет активных заказов',
    empty_history: 'История пуста',
    empty_orders_sub: 'Заказы появятся здесь',
    confirm_cancel_prompt: 'Отменить заказ? Деньги вернутся на баланс.',
    toast_cancelled_refund: 'Заказ отменён, {amount} вернулись',
    toast_slot_taken: 'Это время только что заняли',
    toast_insufficient: 'Недостаточно средств',
    err_create_order: 'Не удалось создать заказ',
    err_cancel_order: 'Ошибка отмены заказа',
    err_invoice: 'Ошибка создания счёта',
    error_future_time: 'Это время уже прошло',
    task_time_busy: 'Это время только что заняли',
    insufficient_funds: 'Недостаточно средств на балансе',
    invalid_date_format: 'Неверный формат даты',
    order_not_found: 'Заказ не найден',
    order_cannot_be_cancelled: 'Заказ уже начался или отменён',
    server_error: 'Ошибка сервера, попробуйте позже',
    request_failed: 'Ошибка запроса',

    // Wallet / Balance
    wallet_title: 'Баланс',
    available_label: 'Доступно',
    hours_estimate: '≈ {hours} ч продвижения по вашему тарифу ${price}/ч',
    tiers_title: 'Цена часа зависит от пополнения',
    tier_range_up_to_50: 'до $50',
    tier_range_from_50: 'от $50',
    tier_range_from_200: 'от $200',
    tier_note_hourly: 'за час',
    tier_percent_10: '−10%',
    tier_percent_20: '−20%',
    tier_percent_30: '−30%',
    topup_amount_label: 'Сумма пополнения',
    amount_hint: '≈ {hours} ч по ${price}',
    upsell_50: 'Добавьте ${diff} — и час будет стоить $8 вместо $10',
    upsell_200: 'От $200 час стоит $7 — это {h200} ч вместо {hCurrent} ч',
    transactions_title: 'Операции',
    tx_empty: 'Операций пока нет',
    tx_topup: 'Пополнение · {merchant}',
    tx_order: 'Заказ · {model}',
    tx_refund: 'Возврат · {model}',
    btn_pay_crypto: 'Оплатить ${amount} криптой',
    btn_pay_creating: 'Формируем счёт…',
    crypto_currencies: 'BTC · ETH · USDT',

    // Referral
    ref_title: 'Партнёрка',
    ref_desc: 'Приглашайте моделей и студии — получайте {pct} с каждого их пополнения на свой баланс.',
    ref_invited: 'Приглашено',
    ref_earned: 'Заработано',
    ref_link_label: 'Ваша ссылка',
    btn_copy: 'Копировать',
    toast_link_copied: 'Ссылка скопирована',
    btn_share_telegram: 'Поделиться в Telegram',
    share_text: 'Продвижение комнаты на Stripchat по расписанию',
    how_works_title: 'Как это работает',
    how_step1: 'Друг открывает бота по вашей ссылке',
    how_step2: 'Пополняет баланс и заказывает продвижение',
    how_step3: 'Вам на баланс приходит {pct}',
    invited_list_title: 'Приглашённые',
    ref_empty: 'Пока никого',
    ref_empty_sub: 'Здесь появятся приглашённые и начисления',
  },

  en: {
    // Navigation / Tabs
    tab_order: 'Order',
    tab_orders: 'My Orders',
    tab_wallet: 'Balance',
    tab_referral: 'Affiliate',

    // Days & Months
    wd_0: 'Sun', wd_1: 'Mon', wd_2: 'Tue', wd_3: 'Wed', wd_4: 'Thu', wd_5: 'Fri', wd_6: 'Sat',
    mon_0: 'Jan', mon_1: 'Feb', mon_2: 'Mar', mon_3: 'Apr', mon_4: 'May', mon_5: 'Jun',
    mon_6: 'Jul', mon_7: 'Aug', mon_8: 'Sep', mon_9: 'Oct', mon_10: 'Nov', mon_11: 'Dec',
    month_full_0: 'January', month_full_1: 'February', month_full_2: 'March', month_full_3: 'April',
    month_full_4: 'May', month_full_5: 'June', month_full_6: 'July', month_full_7: 'August',
    month_full_8: 'September', month_full_9: 'October', month_full_10: 'November', month_full_11: 'December',
    cal_wd_mon: 'Mo', cal_wd_tue: 'Tu', cal_wd_wed: 'We', cal_wd_thu: 'Th', cal_wd_fri: 'Fr', cal_wd_sat: 'Sa', cal_wd_sun: 'Su',
    today: 'Today',
    tomorrow: 'Tomorrow',
    seg_today: 'Tod',
    calendar_btn: 'Calendar',
    limit_30_days: 'Up to 30 days',
    hours_unit: 'h',
    min_unit: 'min',

    // Onboarding
    onboard_title: 'Stripchat Room Traffic On Schedule',
    onboard_sub: 'Choose a model and hour — promotion turns on automatically. Hourly billing from balance.',
    onboard_step1_title: 'Top Up Balance',
    onboard_step1_desc: 'With crypto: BTC, ETH, USDT. Larger top-ups reduce hourly rate: $10 → $8 → $7.',
    onboard_step2_title: 'Choose Free Time',
    onboard_step2_desc: 'Grid shows time in your local timezone. Busy hours are crossed out.',
    onboard_step3_title: 'Be Online 15 Mins Before',
    onboard_step3_desc: 'The bot will remind you on Telegram. Promotion starts automatically.',
    onboard_guide_link: 'Detailed Instructions',
    onboard_btn_order: 'Create First Order',
    onboard_btn_wallet: 'Top Up Balance First',

    // Order Form
    order_head_sub: 'Stripchat traffic',
    order_title: 'New Order',
    model_label: 'Model',
    model_placeholder: 'username',
    recent_label: 'Recent:',
    date_label: 'Date',
    start_time_label: 'Start Time',
    now_label: 'now',
    legend_free: 'Available',
    legend_busy: 'Busy',
    legend_selected: 'Your Order',
    duration_label: 'Duration',
    online_note_prefix: 'Model must be online from',
    online_note_suffix: '— 15 min before start.',
    how_it_works: 'How it works',
    err_empty_model: 'Enter model username on Stripchat.',
    err_no_window: 'No available window of this duration on this date — pick another day or decrease duration.',
    err_hour_busy: '{time} is already booked — decrease duration or shift start time.',
    err_after_midnight: 'Order must finish before 24:00 — decrease duration or pick earlier time.',
    err_past_time: 'This time has already passed.',
    err_insufficient_prefix: 'Short by',
    err_insufficient_suffix: 'on balance.',
    remaining_label: 'Remaining',
    btn_topup: 'Top Up Balance',
    btn_select_free_time: 'Select Free Time',
    btn_loading_slots: 'Loading slots…',
    btn_order_for: 'Order for ${cost}',
    btn_creating: 'Creating…',

    // Confirm
    confirm_title: 'Order Confirmed',
    starts_in: 'Starts in',
    summary_model: 'Model',
    summary_date: 'Date',
    summary_time: 'Time',
    summary_charged: 'Charged',
    summary_balance: 'Balance',
    remind_telegram: 'Telegram Reminder',
    remind_telegram_sub: 'At {time} — 30 min before start',
    confirm_online_note: 'Model must be online from {time}. You can cancel before start — money is refunded to balance.',
    btn_my_orders: 'My Orders',
    btn_another_order: 'Another Order',

    // Orders list
    orders_title: 'My Orders',
    tab_upcoming: 'Upcoming',
    tab_history: 'History',
    status_running: 'Running',
    status_scheduled: 'Scheduled',
    status_completed: 'Completed',
    status_cancelled: 'Cancelled',
    left_label: 'Remaining',
    online_from: 'online from',
    remind_tag: 'reminder on',
    refunded_label: 'refunded',
    btn_cancel: 'Cancel',
    btn_repeat: 'Repeat',
    btn_new_order: '+ New Order',
    empty_upcoming: 'No active orders',
    empty_history: 'History is empty',
    empty_orders_sub: 'Orders will appear here',
    confirm_cancel_prompt: 'Cancel order? Money will be refunded to balance.',
    toast_cancelled_refund: 'Order cancelled, {amount} refunded',
    toast_slot_taken: 'This time slot was just booked',
    toast_insufficient: 'Insufficient funds',
    err_create_order: 'Failed to create order',
    err_cancel_order: 'Failed to cancel order',
    err_invoice: 'Failed to create invoice',
    error_future_time: 'This time has already passed',
    task_time_busy: 'This time slot was just booked',
    insufficient_funds: 'Insufficient funds on balance',
    invalid_date_format: 'Invalid date format',
    order_not_found: 'Order not found',
    order_cannot_be_cancelled: 'Order has already started or ended',
    server_error: 'Server error, please try again later',
    request_failed: 'Request failed',

    // Wallet / Balance
    wallet_title: 'Balance',
    available_label: 'Available',
    hours_estimate: '≈ {hours} h promotion at your ${price}/h tier',
    tiers_title: 'Hourly rate depends on top-up amount',
    tier_range_up_to_50: 'up to $50',
    tier_range_from_50: 'from $50',
    tier_range_from_200: 'from $200',
    tier_note_hourly: 'per hour',
    tier_percent_10: '−10%',
    tier_percent_20: '−20%',
    tier_percent_30: '−30%',
    topup_amount_label: 'Top-up Amount',
    amount_hint: '≈ {hours} h at ${price}',
    upsell_50: 'Add ${diff} — and hour will cost $8 instead of $10',
    upsell_200: 'From $200 hour costs $7 — that is {h200} h instead of {hCurrent} h',
    transactions_title: 'Transactions',
    tx_empty: 'No transactions yet',
    tx_topup: 'Top-up · {merchant}',
    tx_order: 'Order · {model}',
    tx_refund: 'Refund · {model}',
    btn_pay_crypto: 'Pay ${amount} with crypto',
    btn_pay_creating: 'Generating invoice…',
    crypto_currencies: 'BTC · ETH · USDT',

    // Referral
    ref_title: 'Affiliate Program',
    ref_desc: 'Invite models and studios — receive {pct} of each of their top-ups directly to your balance.',
    ref_invited: 'Invited',
    ref_earned: 'Earned',
    ref_link_label: 'Your link',
    btn_copy: 'Copy',
    toast_link_copied: 'Link copied',
    btn_share_telegram: 'Share in Telegram',
    share_text: 'Scheduled Stripchat room promotion',
    how_works_title: 'How it works',
    how_step1: 'A friend opens the bot with your link',
    how_step2: 'Tops up balance and orders promotion',
    how_step3: 'You get {pct} credited to your balance',
    invited_list_title: 'Invited Users',
    ref_empty: 'No one yet',
    ref_empty_sub: 'Invited users and earnings will appear here',
  }
};

const I18nContext = createContext({
  lang: 'ru',
  setLang: () => {},
  t: (key, vars) => key,
});

export function detectLanguage() {
  if (typeof window !== 'undefined') {
    const tgLang = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
    if (tgLang && tgLang.toLowerCase().startsWith('en')) return 'en';
    if (tgLang && tgLang.toLowerCase().startsWith('ru')) return 'ru';
    const saved = localStorage.getItem('app_lang');
    if (saved === 'en' || saved === 'ru') return saved;
  }
  return 'ru'; // default to Russian as in spec
}

export function I18nProvider({ children, initialLang }) {
  const [lang, setLangState] = useState(initialLang || detectLanguage);

  const setLang = (newLang) => {
    setLangState(newLang);
    try {
      localStorage.setItem('app_lang', newLang);
    } catch (e) {}
  };

  const t = (key, vars = {}) => {
    const dict = dictionaries[lang] || dictionaries.ru;
    let str = dict[key] || dictionaries.ru[key] || key;
    Object.keys(vars).forEach((v) => {
      str = str.replaceAll(`{${v}}`, vars[v]);
    });
    return str;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}

export function translateError(err, t) {
  if (!err) return '';
  if (err.code && dictionaries.ru[err.code]) {
    return t(err.code);
  }
  if (err.message && dictionaries.ru[err.message]) {
    return t(err.message);
  }
  if (err.status === 409) return t('toast_slot_taken');
  if (err.status === 402) return t('toast_insufficient');
  if (err.status === 404) return t('err_create_order');
  return err.message || t('server_error');
}
